export const alphabet = "abcdefghijklmnopqrstuvwxyz";
export const frequencyOrder = "etaoinsrhdlucmfywgpbvkxqjz";
